(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bk-browse-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bk-grid-view')) {
    customElements.define('bk-grid-view', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.root = this.closest('collection-component');
        if (!this.root) return;
        ['desktop', 'mobile'].forEach(viewport => {
          const buttons = Array.from(this.querySelectorAll(`button[data-grid-size="${viewport}"]`));
          const key = `bk-grid-${viewport}`;
          let value = viewport === 'desktop' ? '4' : '2';
          try { value = localStorage.getItem(key) || value; } catch {}
          if (!buttons.some(button => button.value === value)) value = viewport === 'desktop' ? '4' : '2';
          const apply = selected => {
            this.root.style.setProperty(`--${key}`, selected);
            if (viewport === 'mobile') this.root.dataset.bkMobileColumns = selected;
            buttons.forEach(button => button.setAttribute('aria-pressed', String(button.value === selected)));
          };
          apply(value);
          buttons.forEach(button => button.addEventListener('click', () => {
            apply(button.value);
            try { localStorage.setItem(key, button.value); } catch {}
          }, { signal: this.controller.signal }));
        });
        this.hidden = false;
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (!customElements.get('bk-card-gallery')) {
    customElements.define('bk-card-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.frame = this.closest('.card__inner');
        this.image = this.frame?.querySelector('.card__media .media > img');
        this.slides = Array.from(this.querySelectorAll('template[data-gallery-image]'));
        if (!this.image || this.slides.length < 2) return;
        this.index = 0;
        this.pointer = null;
        this.suppressClickUntil = 0;
        this.frame.dataset.bkGallery = '';
        this.gestureTarget = this.frame;
        this.hidden = false;
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-gallery-step]');
          if (!button) return;
          event.preventDefault();
          event.stopPropagation();
          this.show(this.index + Number(button.dataset.galleryStep));
        }, { signal });
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'Home') this.show(0);
          else if (event.key === 'End') this.show(this.slides.length - 1);
          else this.show(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
        }, { signal });
        this.mobileQuery = matchMedia('(max-width: 749px)');
        this.mobileQuery.addEventListener('change', () => this.syncMobileGallery(), { signal });
        this.syncMobileGallery();
        this.resize = new ResizeObserver(() => this.updateSizes());
        this.resize.observe(this.frame);
        this.updateSizes();
      }
      syncMobileGallery() {
        const mobile = this.mobileQuery.matches;
        if (mobile && !this.track) {
          const link = this.frame.querySelector('.bk-card-image-link');
          if (!link) return;
          this.track = document.createElement('div');
          this.track.className = 'bk-card-gallery__track';
          this.slides.forEach(template => {
            const slide = document.createElement('a');
            slide.className = 'bk-card-gallery__slide';
            slide.href = link.href;
            slide.setAttribute('aria-label', link.getAttribute('aria-label'));
            slide.append(template.content.querySelector('img').cloneNode(true));
            this.track.append(slide);
          });
          this.prepend(this.track);
          const signal = this.controller.signal;
          this.track.addEventListener('scroll', () => {
            this.suppressClickUntil = performance.now() + 350;
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(() => {
              const step = this.track.firstElementChild.getBoundingClientRect().width;
              if (!step) return;
              this.index = Math.min(this.slides.length - 1, Math.round(Math.abs(this.track.scrollLeft) / step));
              this.updateCount();
            });
          }, { passive: true, signal });
          this.track.addEventListener('pointerdown', event => {
            this.suppressClickUntil = 0;
            this.pointer = { x: event.clientX, y: event.clientY };
          }, { passive: true, signal });
          this.track.addEventListener('pointermove', event => {
            if (this.pointer && Math.hypot(event.clientX - this.pointer.x, event.clientY - this.pointer.y) > 10) {
              this.suppressClickUntil = performance.now() + 350;
            }
          }, { passive: true, signal });
          this.track.addEventListener('pointercancel', () => {
            this.pointer = null;
            this.suppressClickUntil = performance.now() + 350;
          }, { signal });
          this.track.addEventListener('pointerup', () => { this.pointer = null; }, { signal });
          this.track.addEventListener('click', event => {
            if (performance.now() < this.suppressClickUntil) {
              event.preventDefault();
              event.stopPropagation();
            }
          }, { capture: true, signal });
        }
        this.frame.toggleAttribute('data-bk-mobile-gallery', mobile && !!this.track);
        this.show(this.index, false);
      }
      updateSizes() {
        const width = Math.ceil(this.frame.getBoundingClientRect().width);
        if (width > 0 && width !== this.lastMeasuredWidth) {
          this.lastMeasuredWidth = width;
          this.image.sizes = `${width}px`;
          this.track?.querySelectorAll('img').forEach(image => { image.sizes = `${width}px`; });
          if (this.mobileQuery?.matches && this.track) {
            const step = this.track.firstElementChild.getBoundingClientRect().width;
            const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
            this.track.scrollTo({ left: this.index * step * direction, behavior: 'instant' });
          }
        }
      }
      show(index, smooth = true) {
        this.index = (index + this.slides.length) % this.slides.length;
        if (this.mobileQuery?.matches && this.track) {
          const step = this.track.firstElementChild.getBoundingClientRect().width;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollTo({ left: this.index * step * direction, behavior: smooth && !reduce ? 'smooth' : 'instant' });
          this.updateCount();
          return;
        }
        const source = this.slides[this.index].content.querySelector('img');
        if (!source) return;
        this.updateSizes();
        ['srcset', 'src', 'alt', 'width', 'height'].forEach(name => {
          const value = source.getAttribute(name);
          if (value !== null) this.image.setAttribute(name, value);
        });
        this.updateCount();
      }
      updateCount() {
        this.querySelector('.bk-card-gallery__count').textContent = `${this.index + 1} / ${this.slides.length}`;
        const status = this.querySelector('[data-gallery-status]');
        status.textContent = status.dataset.label.replace('[current]', this.index + 1).replace('[total]', this.slides.length);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        this.track?.remove();
        this.track = null;
        this.frame?.removeAttribute('data-bk-mobile-gallery');
      }
    });
  }
  function setupBackToFilters() {
    const main = document.querySelector('main[data-template="collection"]');
    const toolbar = main?.querySelector('#main-collection-filters');
    if (!toolbar || main.querySelector('.bk-back-to-filters')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bk-back-to-filters';
    button.setAttribute('aria-label', 'Back to filters and sort');
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 15 6-6 6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    main.append(button);
    const controller = new AbortController();
    let frame;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!button.isConnected) { controller.abort(); return; }
        const headerBottom = document.querySelector('.section-header')?.getBoundingClientRect().bottom || 0;
        button.style.setProperty('--bk-back-top', `${Math.max(0, headerBottom) + 8}px`);
        button.toggleAttribute('data-visible', window.innerWidth < 750 && toolbar.getBoundingClientRect().bottom < 0);
      });
    };
    window.addEventListener('scroll', update, { passive:true, signal:controller.signal });
    window.addEventListener('resize', update, { passive:true, signal:controller.signal });
    button.addEventListener('click', () => {
      const target = toolbar.querySelector('.mobile-facets__disclosure > summary, summary');
      target?.focus({ preventScroll:true });
      const header = document.querySelector('.section-header');
      const top = Math.max(0, window.scrollY + toolbar.getBoundingClientRect().top - (header?.getBoundingClientRect().height || 0) - 16);
      window.scrollTo({ top, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupBackToFilters, { once:true });
  else setupBackToFilters();
  document.addEventListener('shopify:section:load', setupBackToFilters);
  } catch(e) { console.error(e); }
})();

})();
